import { isValidCpr, Region } from '@monthio/react-components'
import i18n from 'i18next'
import { ValidateCprAgainstServerFunction, ValidateCprFunction } from '../types'
import { getNationalIdentificationNumberErrorTranslation } from '../utils/getNationalIdentificationNumberErrorTranslation'

export const validateSpanishNationalIdentificationNumber: ValidateCprFunction =
	async (
		cprNumber,
		validateCprAgainstServer: ValidateCprAgainstServerFunction,
	) => {
		const nationalId = cprNumber
		if (!nationalId) {
			return {
				success: false,
				output: i18n.t('validation-fieldRequired'),
			}
		}

		const validatedNationalId = isValidCpr(nationalId, {
			region: Region.Spain,
		})

		if (!validatedNationalId.valid) {
			return {
				success: false,
				output: i18n.t(
					'es-consumerInputs-personalInformation-identityNumberInvalid-text',
				),
			}
		}

		const cprServerResponse = await validateCprAgainstServer(nationalId)

		if (!cprServerResponse.isValid) {
			return {
				success: false,
				output: getNationalIdentificationNumberErrorTranslation(
					cprServerResponse.error?.message,
				),
			}
		}

		return {
			success: true,
			output: nationalId,
		}
	}
